
import RichTextEditor from './RichTextEditor'

export default RichTextEditor
